<template>
  <div class="map-box">
    <p>统一站点名称:<span class="text">{{ address }}  <span :class="[typeLev?'type':'']">{{ typeLev }}</span></span></p>
    <p>站点详细地址:<span class="text">{{ detailedAddress }}</span></p>
    <p>站点经纬度:<span class="text">{{ position }}</span></p>
    <div id="container" class="container" />
    <p>该数据,将用于站点经纬度、电子围栏判断</p>
    <p class="info">
      请务必确保站点位置准确,否则将导致司机无法进入电子围栏,从而无法装货、签收引发考核问题
    </p>
  </div>
</template>

<script>
import Bus from '../bus';

export default {
  data() {
    return {
      map: null,
      positionXY: {
        lng: '',
        lat: '',
      },
      marker: null,
      position: '',
      detailedAddress: '',
      address: '',
      typeLev: '',
    };
  },
  created() {
    Bus.$on('addressInfo', this.setAddress);
    Bus.$on('poiInfo', this.setPoiInfo);
    Bus.$on('examineState', this.viewDetail);
    Bus.$on('viewSiteDetail', this.viewDetail);
    Bus.$on('newState', this.newSite);
    Bus.$on('poiType', this.SetTypeLev);
  },
  destroyed() {
    Bus.$off('addressInfo', this.setAddress);
    Bus.$off('poiInfo', this.setPoiInfo);
    Bus.$off('examineState', this.viewDetail);
  },
  mounted() {
    this.showMap();
  },
  methods: {
    newSite() {
      this.position = '';
      this.detailedAddress = '';
      this.address = '';
      this.typeLev = '';
    },
    SetTypeLev(e) {
      this.typeLev = e;
    },
    viewDetail(e) {
      const {
        poiExt,
      } = e;
      if (poiExt) {
        this.detailedAddress = (poiExt.province || poiExt.provinceName) + (poiExt.city || poiExt.cityName) + (poiExt.county || poiExt.countyName) + poiExt.address;
        this.positionXY.lng = poiExt.lon || poiExt.longitude;
        this.positionXY.lat = poiExt.lat || poiExt.latitude;
        this.address = poiExt.name || poiExt.poiName;
        this.typeLev = poiExt.typeLev3 || '';
        this.position = `${poiExt.lon || poiExt.longitude || ''}, ${poiExt.lat || poiExt.latitude || ''}`;
      }
      this.showMap();
    },
    setPoiInfo(e) {
      const {
        province, city, county, lon, lat, name, typeLev3,
      } = e;
      this.address = name;
      this.position = `${lon},${lat}`;
      this.detailedAddress = province + city + county + name;
      this.typeLev = typeLev3;
      this.positionXY = {
        lng: lon,
        lat,
      };
      this.addMarker();
    },
    setAddress(e) {
      this.detailedAddress = `${e[0]}   ${e[1]}  ${e[2]}`;
    },
    showMap() {
      /* global AMap */
      if (this.positionXY.lng) {
        this.map = new AMap.Map('container', {
          center: [this.positionXY.lng, this.positionXY.lat],
          zoom: 15,
        });
        this.map.setFitView();
      } else {
        this.map = new AMap.Map('container', {
          resizeEnable: true,
          zoom: 15,
        });
        this.positionXY = this.map.getCenter(); // 获取当前定位的经纬度标点用
        this.map.setFitView();
      }
      this.map.on('click', this.showInfoClick);// 给地图绑定点击事件
      this.addMarker();
    },
    // 地图点击事件
    showInfoClick(e) {
      this.positionXY = e.lnglat;
      this.position = this.positionXY;
      this.addMarker();
      this.setposition();
      this.typeLev = '';
    },
    addMarker() {
      if (this.marker) {
        this.map.remove(this.marker);
      }
      AMap.plugin(['AMap.Marker', 'AMap.Pixel'], () => {
        this.marker = new AMap.Marker({
          offset: new AMap.Pixel(-13, -30),
          position: new AMap.LngLat(this.positionXY.lng, this.positionXY.lat),
        });
        this.marker.setMap(this.map);
      });
      this.map.setFitView();
    },
    // 根据经纬度进行定位
    setposition() {
      AMap.plugin(['AMap.Geocoder'], () => {
        const geocoder = new AMap.Geocoder({
          city: '010', // 城市设为北京，默认：“全国”
          radius: 1000, // 范围，默认：500
        });
        geocoder.getAddress([this.positionXY.lng, this.positionXY.lat], (status, result) => {
          if (status === 'complete' && result.regeocode) {
            const address = result.regeocode.formattedAddress;
            this.detailedAddress = address;
            const {
              township, street, neighborhood, province, city, district,
            } = result.regeocode.addressComponent;
            this.cityInfo = [province, city, district];
            this.address = township + street + neighborhood;
            this.$emit('positionYx', {
              position: this.position, detailedAddress: this.detailedAddress, address: this.address, cityInfo: this.cityInfo,
            });
          } else {
            this.$message.error('根据经纬度查询地址失败');
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container{
  width: 100%;
  height: 400px;
  margin: 10px;
}
.map-box{
  p{
    margin-bottom: 5px;
  }
}
.text{
  margin-left: 10px;
}
.info{
  color: red;
  font-size: 14px;
}
.type{
  background: #00af66;
  margin-left: 10px;
  font-size: 12px;
  color: #fff;
  padding: 2px 5px;
  border-radius: 2px;
}
</style>
